import React from "react";

import { Icon } from "@chakra-ui/react";
import {
  MdBarChart,
  MdOutlineAnalytics,
  MdHome,
  MdLock,
  MdOutlineShoppingCart,
} from "react-icons/md";

// Admin Imports
import MainDashboard from "views/admin/default";
import NFTMarketplace from "views/admin/marketplace";
import Dashboard from "views/admin/dashboard";
import DataTables from "views/admin/dataTables";

// Auth Imports
import SignInCentered from "views/auth/signIn";
import { FaLaptopHouse } from "react-icons/fa";
import Report from "views/admin/relatorio";
import Reports from "views/admin/relatorios";
import NewReport from "views/admin/novo-relatorio";

export const unloggedRoutes = [
  {
    name: "Sign In",
    layout: "/auth",
    path: "/entrar",
    showInMenu: false,
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: SignInCentered,
  }
]

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "/dashboard",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: Dashboard,
  },
  {
    name: "Relatórios",
    layout: "/admin",
    path: "/relatorios",
    icon: <Icon as={MdOutlineAnalytics} width='20px' height='20px' color='inherit' />,
    component: Reports,
  },
  {
    name: "Relatório",
    layout: "/admin",
    path: "/relatorio/:id",
    icon: <Icon as={MdOutlineAnalytics} width='20px' height='20px' color='inherit' />,
    component: Report,
    showInMenu: false
  },
  {
    name: "Novo relatório",
    layout: "/admin",
    path: "/novo-relatorio",
    showInMenu: true,
    icon: <Icon as={MdOutlineAnalytics} width='20px' height='20px' color='inherit' />,
    component: NewReport,
  },
  {
    name: "Main Dashboard 2",
    layout: "/admin",
    path: "/default",
    showInMenu: false,
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: MainDashboard,
  },
  {
    name: "NFT Marketplace",
    layout: "/admin",
    showInMenu: false,
    path: "/nft-marketplace",
    icon: (
      <Icon
        as={MdOutlineShoppingCart}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: NFTMarketplace,
    secondary: true,
  },
  {
    name: "Data Tables",
    layout: "/admin",
    icon: <Icon as={MdBarChart} width='20px' height='20px' color='inherit' />,
    path: "/data-tables",
    showInMenu: false,
    component: DataTables,
  }
];

export default routes